<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showOffer"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="
            change-height
            fixed
            center-h-v
            bg-white
            rounded-md
            shadow-2xl
            sm:w-3/5
            w-full
          "
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Send offfer to John Doe</p>
            <img
              v-if="!loading"
              class="
                h-6
                object-contain
                cursor-pointer
                hover:shadow-lg
                bg-primary
                rounded-md
              "
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="p-5 flex flex-col gap-4">
            <div class="text-sm">
              <label class="block pb-1">Email Template</label>
              <select class="p-2 bg-gray-200 rounded-xl w-full">
                <option>Offer</option>
                <option>Hired</option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Email</label>
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-xl w-full"
                placeholder="john@gmail.com"
              />
            </div>
            <div class="text-sm">
              <label class="pb-2 block">Email Body</label>
              <div class="h-72">
                <textarea
                  class="p-1 bg-gray-200 rounded-xl w-full h-full"
                  cols="20"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Send Offer
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name: "SendOffer",
  props: ["showOffer"],

  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.change-height {
  transition: height 0.15s ease-out;
}
</style>